(function () {
  const html = document.documentElement

  function update () {
    const atTop = window.scrollY < 4 && document.querySelector('.lo-deal-band')
    if (atTop) {
      html.classList.add('lo-at-top')
    } else {
      html.classList.remove('lo-at-top')
    }
  }

  window.addEventListener('scroll', update, { passive: true })
  window.addEventListener('resize', update, { passive: true })
  document.addEventListener('DOMContentLoaded', update)
  update()
})()
